var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"common",
		"auth-auth-module"
	],
	"app/pages/channel-mapping/channel-mapping.module": [
		"./src/app/pages/channel-mapping/channel-mapping.module.ts",
		"default~app-pages-channel-mapping-channel-mapping-module~app-pages-pages-module",
		"common"
	],
	"app/pages/equip-monitoring/equip-monitoring.module": [
		"./src/app/pages/equip-monitoring/equip-monitoring.module.ts",
		"app-pages-equip-monitoring-equip-monitoring-module"
	],
	"app/pages/inventory/inventory.module": [
		"./src/app/pages/inventory/inventory.module.ts",
		"common",
		"app-pages-inventory-inventory-module"
	],
	"app/pages/manage/manage.module": [
		"./src/app/pages/manage/manage.module.ts",
		"common",
		"app-pages-manage-manage-module"
	],
	"app/pages/pad/pad.module": [
		"./src/app/pages/pad/pad.module.ts",
		"default~app-pages-pad-pad-module~app-pages-treatments-realtime-realtime-module~app-pages-treatments-~f93f3835",
		"common",
		"app-pages-pad-pad-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~app-pages-channel-mapping-channel-mapping-module~app-pages-pages-module",
		"default~app-pages-pages-module~app-pages-user-user-module",
		"common",
		"app-pages-pages-module"
	],
	"app/pages/treatments/realtime/realtime.module": [
		"./src/app/pages/treatments/realtime/realtime.module.ts",
		"default~app-pages-pad-pad-module~app-pages-treatments-realtime-realtime-module~app-pages-treatments-~f93f3835",
		"common"
	],
	"app/pages/treatments/treatments.module": [
		"./src/app/pages/treatments/treatments.module.ts",
		"default~app-pages-pad-pad-module~app-pages-treatments-realtime-realtime-module~app-pages-treatments-~f93f3835",
		"default~app-pages-treatments-treatments-module~app-pages-treatments-upload-treatment-upload-treatmen~82c786cc",
		"common",
		"app-pages-treatments-treatments-module"
	],
	"app/pages/treatments/upload-treatment/upload-treatment.module": [
		"./src/app/pages/treatments/upload-treatment/upload-treatment.module.ts",
		"default~app-pages-treatments-treatments-module~app-pages-treatments-upload-treatment-upload-treatmen~82c786cc",
		"common"
	],
	"app/pages/user/user.module": [
		"./src/app/pages/user/user.module.ts",
		"default~app-pages-pages-module~app-pages-user-user-module",
		"common"
	],
	"app/pages/wells/wells.module": [
		"./src/app/pages/wells/wells.module.ts",
		"app-pages-wells-wells-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;